
import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";

const OrderCard = ({
  order,
  orderNumber,
  date,
  productName,
  quantity,
  price,
  status = "Unknown", 
  productImage,
}) => {
  const statusClass = status ? status.toLowerCase() : "unknown"; 
  const navigate = useNavigate(); 

  const handleNavigateToOrderDetails = (orderId) => {
    navigate(`/orderdetails/${orderId}`, {}); 
  }

  return (
    <div className="order-card">
      <div className="order-header">
        <div>
          <h5 className="order-title">Order #{orderNumber}</h5>
          <p className="order-date">Placed on {date}</p>
        </div>
        <span className={`status-badge ${statusClass}`}>{status}</span> 
      </div>
      <div className="order-content">
        <div className="order-product">
          <div className="product-image">
            <img
              src={productImage || "/placeholder.svg?height=64&width=64"}
              alt="Product"
              className="product-img"
            />
          </div>
          <div className="product-details">
            <h5 className="product-name">{productName}</h5>
            <p className="product-quantity">Quantity: {quantity}</p>
            <p className="product-price">{price}</p>
          </div>
          <div className="product-actions">
            <p onClick={() => handleNavigateToOrderDetails(orderNumber)} className="view-details-button">
              View Details
            </p>
          </div>
        </div>
      </div>
      <div className="order-footer">
        <div className="order-actions">
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
